// start:ng42.barrel
export * from './IMessage';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/Messages/index.ts